import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { CustomerOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { Customer } from '../../../classes';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-select-customer-dialog',
  templateUrl: './select-customer-dialog.component.html',
  styleUrls: ['./select-customer-dialog.component.css']
})
export class SelectCustomerDialogComponent implements OnDestroy, OnInit {

  customers: CustomerOverviewModel[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectCustomerDialogComponent>,
    private _customerService: CustomerService
  ) { }

  close(){
    this._dialogRef.close();
  }

  customerClicked(customer: Customer){
    this._dialogRef.close(customer);
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.customers.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._customerService
        .searchCustomersByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialCustomers();
    this.customers = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._customerService.searchCustomersByString(search, this.page);
      })).subscribe((result: PaginationResponse<CustomerOverviewModel[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<CustomerOverviewModel[]>) => {
    if(this.page.pageNumber === 1) this.customers = [];
    this.customers.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialCustomers(){
    this._customerService.customers$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((customers: Customer[]) => this.customers = customers as any);
  }

}
